module.exports = __webpack_public_path__ + "static/media/dont-be-bullying.69b121db.png";